'use client';

import { c as _c } from "react/compiler-runtime";
import './horizontal-scroll-area.scss';
import { type CSSProperties, type ComponentPropsWithoutRef, type FC, type ReactElement } from 'react';
import { useHorizontalScrollArea } from './horizontal-scroll-area.logic.ts';
export type HorizontalScrollAreaProps = Omit<ComponentPropsWithoutRef<'div'>, 'children' | 'style' | 'className'> & {
  /** The existing horizontal scroll viewport. */
  children: ReactElement;
  /** The surface color that the overflow indicators blend into. */
  indicatorColor?: CSSProperties['backgroundColor'];
};

/**
 * Adds design system UI indicators for horizontal scroll containers.
 */
export const HorizontalScrollArea: FC<HorizontalScrollAreaProps> = t0 => {
  const $ = _c(14);
  let children;
  let indicatorColor;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      indicatorColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = indicatorColor;
    $[3] = props;
  } else {
    children = $[1];
    indicatorColor = $[2];
    props = $[3];
  }
  const {
    canScrollEnd,
    canScrollStart,
    scrollbarHeight,
    wrapperRef
  } = useHorizontalScrollArea();
  const t1 = canScrollEnd ? "true" : undefined;
  const t2 = canScrollStart ? "true" : undefined;
  const t3 = `${scrollbarHeight}px`;
  let t4;
  if ($[4] !== indicatorColor || $[5] !== t3) {
    t4 = {
      "--h-scroll-area-fade-color": indicatorColor,
      "--h-scroll-area-scrollbar-height": t3
    };
    $[4] = indicatorColor;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = t4 as CSSProperties;
  let t6;
  if ($[7] !== children || $[8] !== props || $[9] !== t1 || $[10] !== t2 || $[11] !== t5 || $[12] !== wrapperRef) {
    t6 = <div {...props} ref={wrapperRef} className="HorizontalScrollArea" data-overflow-end={t1} data-overflow-start={t2} style={t5}>{children}</div>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
    $[12] = wrapperRef;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};